import { LucideIcon, icons } from "lucide-react";
import { cn } from "../../../lib/utils";

export function getLucideIcon(value?: string): LucideIcon | undefined {
  if (!value) return undefined;
  return (icons as Record<string, LucideIcon>)[value];
}

export function isLucideIconName(value?: string): boolean {
  return !!getLucideIcon(value);
}

interface TraitIconProps {
  value?: string;
  fallback?: LucideIcon;
  className?: string;
}

export function TraitIcon({ value, fallback: Fallback, className }: TraitIconProps) {
  const LucideMatch = getLucideIcon(value);

  if (LucideMatch) {
    return <LucideMatch className={className} />;
  }

  if (value) {
    return (
      <span className={cn("inline-flex items-center justify-center leading-none", className)}>
        {value}
      </span>
    );
  }

  if (Fallback) {
    return <Fallback className={className} />;
  }

  return null;
}
